import ToolTip from 'Components/ToolTip'
import { TooltipMsg } from 'Components/ToolTipMessage'
import env from 'environment_system/env_system'
import { useFormikContext } from 'formik'
import { checkValidObject, loadArraySum } from 'GenericForms/Helper'
import { RootState } from 'index'
import React from 'react'
import { useSelector } from 'react-redux'
import { Row, Col } from 'reactstrap'
import { FuelTypes, AddInfoConstant } from 'shared/constants'
interface LNGCargoROBComponentType {
  AdditionalDetailsObject: any;
  count: number;
}

const LNGCargoROB = ({
  AdditionalDetailsObject,
  count,
}: LNGCargoROBComponentType) => {
  /** State variables */
  const { CurrentReport } = useSelector((state: RootState) => state.Reporting);
  const cargoDetailsCurrentReport = CurrentReport?.data?.deck_officer?.cargo_detail ?? null;
  const { values }: { values: any } = useFormikContext();
  return (
    <Row className='mt-3 mb-3 px-2'>
      <Col sm={4}>
        <span className='mb-0'>LNG Cargo ROB before consumption
          <i className='bx bx-info-circle ml-2p' id='initial_rob_msg' /> :
        </span>
        <ToolTip target='initial_rob_msg'
          message={`${TooltipMsg.FuelConsumption
            .filter((item: any) => item.target === 'initial_rob_msg')
            .map((tool: any) => { return tool.message })}`}
        />
        <strong>&nbsp;
          {checkValidObject(cargoDetailsCurrentReport) ?
            cargoDetailsCurrentReport?.total_amount_of_cargo_onboard : (parseFloat(values?.lngCargoROB?.cargo_rob))} mt
        </strong>
      </Col>
      <Col sm={5}>
        <span className='mb-0'>LNG Cargo ROB after consumption
          <i className='bx bx-info-circle ml-2p' id='cargo_rob_msg' /> :
        </span>
        <ToolTip target='cargo_rob_msg'
          message={`${TooltipMsg.FuelConsumption
            .filter((item: any) => item.target === 'cargo_rob_msg')
            .map((tool: any) => { return tool.message })}`}
        />
        <strong key={count}>&nbsp;
          {(parseFloat(loadArraySum(values?.fuelConsumption, "fuel_type_precedence_id", "fuel_consumed")[FuelTypes.LNG_CARGO]) === null ||
            Number.isNaN(parseFloat(loadArraySum(values?.fuelConsumption, "fuel_type_precedence_id", "fuel_consumed")[FuelTypes.LNG_CARGO]))) ? values?.lngCargoROB?.cargo_rob :
            (((checkValidObject(cargoDetailsCurrentReport) ?
              cargoDetailsCurrentReport?.total_amount_of_cargo_onboard : parseFloat(values?.lngCargoROB?.cargo_rob))
              - parseFloat(loadArraySum(values?.fuelConsumption, "fuel_type_precedence_id", "fuel_consumed")[FuelTypes.LNG_CARGO])))?.toFixed(4)
          } mt
        </strong>
      </Col>
      {env?.additional_info_engg === AddInfoConstant.PROACTIVE_ENGG &&
        <Col sm={3}>
          <span className='mb-0'>LNG FOE :</span>
          <strong>&nbsp;
            {Number.isNaN((parseFloat(AdditionalDetailsObject[0]?.foe_factor) * ((parseFloat(loadArraySum(values?.fuelConsumption, "fuel_type_precedence_id", "fuel_consumed")[FuelTypes.LNG_CARGO]) === null ||
              Number.isNaN(parseFloat(loadArraySum(values?.fuelConsumption, "fuel_type_precedence_id", "fuel_consumed")[FuelTypes.LNG_CARGO]))) ? values?.lngCargoROB?.cargo_rob :
              ((parseFloat(values?.lngCargoROB?.cargo_rob) - parseFloat(loadArraySum(values?.fuelConsumption, "fuel_type_precedence_id", "fuel_consumed")[FuelTypes.LNG_CARGO])))))) === true ? AdditionalDetailsObject[0]?.foe_factor ?? 0 :
              (parseFloat(AdditionalDetailsObject[0]?.foe_factor) * ((parseFloat(loadArraySum(values?.fuelConsumption, "fuel_type_precedence_id", "fuel_consumed")[FuelTypes.LNG_CARGO]) === null ||
                Number.isNaN(parseFloat(loadArraySum(values?.fuelConsumption, "fuel_type_precedence_id", "fuel_consumed")[FuelTypes.LNG_CARGO]))) ? values?.lngCargoROB?.cargo_rob :
                ((parseFloat(values?.lngCargoROB?.cargo_rob) - parseFloat(loadArraySum(values?.fuelConsumption, "fuel_type_precedence_id", "fuel_consumed")[FuelTypes.LNG_CARGO])))))?.toFixed(4)} mt</strong>
        </Col>
      }
    </Row>
  )
}

export default LNGCargoROB
